import React, { useCallback, useContext } from 'react';

import { PrevMedia } from '../../../../components/newUI/PrevMedia/PrevMedia.tsx';
import { EstimateMeasurementsContext } from '../../Context/EstimateMeasurementsContext';

export const ImagePrev = () => {
    const {
        imageList,
        currentIndex,
        currentUrl,
        setCurrentIndex,
        setCurrentUrl,
        setIsOpenPrevImage,
    } = useContext(EstimateMeasurementsContext);

    const onHideModal = useCallback(() => {
        setIsOpenPrevImage(false);
    }, [setIsOpenPrevImage]);

    return (
        <PrevMedia
            currentIndex={currentIndex}
            imageList={imageList}
            setCurrentIndex={setCurrentIndex}
            setCurrentUrl={setCurrentUrl}
            onHideModal={onHideModal}
            currentUrl={currentUrl.previewUrl}
            fileName={currentUrl.file.name}
        />
    );
};
